import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  explanationButton: {
    alignSelf: "flex-start",
  },
}));
